import type { Vendor, LowerCaseEnum } from '@doxyme/types';

export enum Platform {
  Mobile = 'mobile',
  Web = 'web',
  NotDefined = 'not-defined',
}

export type VideoProvider = LowerCaseEnum<typeof Vendor>;

export type PostSessionDTO = {
  channel: string;
  userId: number;
  internal: boolean;
  isWeb: boolean;
  patientPlatform: Platform;
  doctorPlatform: Platform;
  videoProvider: VideoProvider;
  connectionInfo: unknown[];
  participantsCount: number;
  pidList: string;
};

export type LbCallSession = {
  id: string;
  channel: string;
  created: Date;
  endTime: Date;
  duration: number;
  internal: boolean;
  isWeb: boolean;
  patientPlatform: Platform;
  doctorPlatform: Platform;
  timezone: number;
  lastUpdated: Date;
  videoProvider: VideoProvider;
  participantsCount: number;
  connectionInfo: object;
  roomId: string;
  pidList: string;
  mainSessionId: string;
  userId: number;
};

export type PostSessionParticipantsDTO = {
  userId: number;
  participantUuid: string;
  waitTime: number;
};

export type GetSessionsInput = {
  institutionId?: number;
  locationIds?: number[];
  roomIds?: string[];
  userIds?: string[];
  start: string;
  end: string;
  limit: number;
  offset: number;
};

export type SessionResult = {
  id: string;
  created: string;
  endTime?: string | null;
  duration?: number | null;
  roomId: string;
  userId: string;
  firstName: string;
  lastName: string;
  displayName: string;
  slug: string;
};

export type SessionResultForCsv = {
  slug: string;
  startTime: string;
  endTime: string | null;
  duration: string | null;
  waitTime: string | null;
  patientComments: string[];
  patientIssues: string[];
  patientRatings: number[];
  providerComment: string | null;
  providerIssues: string | null;
  providerRating: number | null;
};

export type SessionsResult = {
  total: number;
  callSessions: SessionResult[];
};
